import type { History } from './react-router';
import { createScopedDescriptor } from 'quartz/globalState/api';

export type HistoryBasePath = Readonly<{
  basePathname: string;
  params: Record<string, string>;
}>;

export const HISTORY_INSTANCE = createScopedDescriptor<History>(
  'historyInstance',
  'EXECUTION_CONTEXT'
);

export const HISTORY_BASE_PATH = createScopedDescriptor<HistoryBasePath>(
  'historyBasePath',
  'EXECUTION_CONTEXT'
);
